module.exports = __webpack_public_path__ + "978d88052ae8d96b8254e09a53921ada.MP3";